const GENERATION_LOADING_STEPS = [
  'Assembling AI council',
  'Constructing chain of thought',
  'Adding snazz to title',
  'Generating questions',
  'Increasing pizzazz levels',
  'Building audience',
  'Preparing editor',
];
const GENERATION_LOADING_TITLE = 'Generating survey based on your inputs.';
const RETRYING_GENERATION_TITLE = 'Retrying survey generation.';
const GENERATION_INTERVAL = 5000;

export { GENERATION_LOADING_STEPS, GENERATION_LOADING_TITLE, GENERATION_INTERVAL, RETRYING_GENERATION_TITLE };
